import { createStore } from 'vuex'

const storeFilePond = {
  state: {
    _adjunto: {}
  },
  getters: {
    adjunto: state => state._adjunto
  },
  mutations: {
    setAdjunto (state, payload) {
      state._adjunto = {
        ...payload
      }
    }
  },
  actions: {
    uploadFile ({ commit }, payload) {
      commit('setAdjunto', payload)
    }
  }
}
const store = createStore(storeFilePond)
export default {
  namespaced: true,
  ...store
}
